import { useEffect } from 'react';

/**
 * Tells Prerender.io when the page is safe to cache (meta tags and main content ready).
 * @see https://docs.prerender.io/docs/best-practices-for-crawler-ready-pages
 * @param {boolean} isReady
 */
export function usePrerenderReady(isReady) {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    if (!isReady) {
      window.prerenderReady = false;
      return () => {
        window.prerenderReady = false;
      };
    }

    const frameId = requestAnimationFrame(() => {
      window.prerenderReady = true;
    });

    return () => {
      cancelAnimationFrame(frameId);
      window.prerenderReady = false;
    };
  }, [isReady]);
}
